var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DndPanel = {
    lf: null,
    shapeList: [
        {
            type: 'rect',
            text: '矩形',
        },
        {
            type: 'circle',
            text: '圆形',
        },
        {
            type: 'polygon',
            text: '菱形',
        },
        {
            type: 'star',
            text: '五角星',
        },
        {
            type: 'triangle',
            text: '三角形',
        },
        {
            type: 'hexagon',
            text: '六边形',
        },
    ],
    install: function (lf) {
        DndPanel.lf = lf;
        DndPanel.registerNode();
        lf.setShapeList = function (config) {
            if (!Array.isArray(config)) {
                throw new TypeError('DndPanel 的 ShapeList 必须是数组');
            }
            else if (config.length > 0) {
                DndPanel.shapeList = config;
            }
        };
    },
    render: function (lf, container) {
        container.appendChild(DndPanel.getDnd());
    },
    getDnd: function () {
        var handleMouseDown = DndPanel.handleMouseDown;
        var dndContainer = document.createElement('div');
        dndContainer.className = 'lf-dnd';
        DndPanel.shapeList.forEach(function (shape) {
            var type = shape.type, text = shape.text;
            var dndItem = document.createElement('div');
            var dndIcon = document.createElement('div');
            var dndText = document.createElement('span');
            dndItem.className = 'lf-dnd-item';
            dndIcon.className = "lf-dnd-" + type;
            dndIcon.onmousedown = function () { return handleMouseDown(shape); };
            dndText.innerText = text;
            dndItem.append(dndIcon, dndText);
            dndContainer.appendChild(dndItem);
        });
        return dndContainer;
    },
    registerNode: function () {
        var lf = DndPanel.lf;
        lf.register('star', function (_a) {
            var PolygonNode = _a.PolygonNode, PolygonNodeModel = _a.PolygonNodeModel;
            var StarNode = /** @class */ (function (_super) {
                __extends(StarNode, _super);
                function StarNode() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return StarNode;
            }(PolygonNode));
            var StarModel = /** @class */ (function (_super) {
                __extends(StarModel, _super);
                function StarModel(data, graphModel) {
                    var _this = _super.call(this, data, graphModel) || this;
                    _this.points = [
                        [45, 0],
                        [20, 90],
                        [90, 30],
                        [0, 30],
                        [80, 90],
                    ];
                    return _this;
                }
                return StarModel;
            }(PolygonNodeModel));
            return {
                view: StarNode,
                model: StarModel,
            };
        });
        lf.register('triangle', function (_a) {
            var PolygonNode = _a.PolygonNode, PolygonNodeModel = _a.PolygonNodeModel;
            var TriangleNode = /** @class */ (function (_super) {
                __extends(TriangleNode, _super);
                function TriangleNode() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return TriangleNode;
            }(PolygonNode));
            var TriangleModel = /** @class */ (function (_super) {
                __extends(TriangleModel, _super);
                function TriangleModel(data, graphModel) {
                    var _this = this;
                    if (data.text && typeof data.text === 'string') {
                        data.text = {
                            value: data.text,
                            x: data.x,
                            y: data.y + 20,
                        };
                    }
                    _this = _super.call(this, data, graphModel) || this;
                    _this.points = [
                        [50, 0],
                        [100, 100],
                        [0, 100],
                    ];
                    return _this;
                }
                return TriangleModel;
            }(PolygonNodeModel));
            return {
                view: TriangleNode,
                model: TriangleModel,
            };
        });
        lf.register('ellipse', function (_a) {
            var EllipseNode = _a.EllipseNode, EllipseNodeModel = _a.EllipseNodeModel;
            var MyEllipseNode = /** @class */ (function (_super) {
                __extends(MyEllipseNode, _super);
                function MyEllipseNode() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return MyEllipseNode;
            }(EllipseNode));
            var MyEllipseModel = /** @class */ (function (_super) {
                __extends(MyEllipseModel, _super);
                function MyEllipseModel(data, graphModel) {
                    var _this = _super.call(this, data, graphModel) || this;
                    _this.rx = 60;
                    _this.ry = 40;
                    return _this;
                }
                return MyEllipseModel;
            }(EllipseNodeModel));
            return {
                view: MyEllipseNode,
                model: MyEllipseModel,
            };
        });
        lf.register('hexagon', function (_a) {
            var PolygonNode = _a.PolygonNode, PolygonNodeModel = _a.PolygonNodeModel;
            var HexagonNode = /** @class */ (function (_super) {
                __extends(HexagonNode, _super);
                function HexagonNode() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return HexagonNode;
            }(PolygonNode));
            var HexagonModel = /** @class */ (function (_super) {
                __extends(HexagonModel, _super);
                function HexagonModel(data, graphModel) {
                    var _this = _super.call(this, data, graphModel) || this;
                    _this.points = [
                        [40, 0],
                        [80, 20],
                        [80, 60],
                        [40, 80],
                        [0, 60],
                        [0, 20],
                    ];
                    return _this;
                }
                return HexagonModel;
            }(PolygonNodeModel));
            return {
                view: HexagonNode,
                model: HexagonModel,
            };
        });
    },
    handleMouseDown: function (config) {
        var lf = DndPanel.lf;
        lf.dnd.startDrag(config);
    },
};
export default DndPanel;
export { DndPanel, };
